// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  zoom_api_key: 'pBnBjQgtQMyq2ZLNAdyeXA',
  zoom_secret: 'esLdxWA8JjbtiGKAlaSYe9RWGPtwwGK9FMwp',
  zoom_endpoint: 'https://api.zoom.us/v2/',
  default_page_size: 50,
  content_type: 'application/json',
  apiurl:"https://api.bababalaknathdeothsidh.com/api/",
  apiurl6:"https://api.bababalaknathdeothsidh.com/api/",
  apiurlcore:"https://api.bababalaknathdeothsidh.com/",
  email:'dharminder@cybrain.co.in',
  zoomsubdomain:"https://livelectures.hitbullseye.com/LiveLectures",
  // sitekey:'6Lf6k5QpAAAAAGzRZ4yM8WApFMKIFM_cqlqCfOwW',
  // secretkey:'6Lf6k5QpAAAAAAiEHpQA-FfZC8wZSUhGq6_fRsGP'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
